import { useState, useEffect, useContext } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { AuthContext } from "../context/auth";
import { useNavigation } from "react-router-dom";
import api from "../api/api";
import { Button, Chip } from "@heroui/react";

const TokenExpiryModal = () => {

  const { setIsAuthenticated } = useContext(AuthContext);
  const [timeLeft, setTimeLeft] = useState(900); // 15 minutes (900s)
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {

    const tokenExpiration = localStorage.getItem("token_expiration");

    if (!tokenExpiration) return;

    const expirationTime = new Date(tokenExpiration).getTime();

    const interval = setInterval(() => {

      const now = new Date().getTime();
      const remainingTime = Math.max((expirationTime - now) / 1000, 0);
      setTimeLeft(Math.floor(remainingTime));

      if (remainingTime <= 60) {
        setShowModal(true); // Afficher le modale 1 min avant expiration
      }

      if (remainingTime <= 0) {
        clearInterval(interval);
        setShowModal(false);
        localStorage.removeItem("token");
        window.location.href = "/login"

      }
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft]);

  const handleExtendSession = async () => {

    try {
      
      const response = await api.auth.auto_login();

      if (response.token) {

        console.log("Token renouvelé !");

        localStorage.setItem("token", response.token);
        const newExpiration = new Date().getTime() + 5 * 60 * 1000; // Ajout de 5 minutes
        localStorage.setItem("token_expiration", new Date(newExpiration).toISOString());
        setTimeLeft(300);
        setShowModal(false);
        setIsAuthenticated(true);
      }
    } catch (error) {
      console.error("Erreur de renouvellement du token :", error);
      // localStorage.removeItem("token");
      setIsAuthenticated(false);
    }
  };

  if (!showModal) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      className="fixed top-0 dark:bg-red-900 right-[40%] bg-red-700 text-white p-4 rounded-lg shadow-lg flex items-center space-x-4 my-2"
    >
      <div>
        <span className="text-sm font-semibold text-gray-100">Votre session expire bientôt !</span>
        <div className="flex justify-between items-center w-[20vw]">
          <Chip color="default" className="text-md mt-2">
            {Math.floor(timeLeft / 60)}:{(timeLeft % 60).toString().padStart(2, "0")}
          </Chip>
          <Button
            onPress={handleExtendSession}
            color="default"
            variant="ghost"

          >
            Continuer
          </Button>
        </div>
      </div>
      
    </motion.div>
  );
};

export default TokenExpiryModal;
